import React from 'react';

import EcommerceSavingSales from 'src/sections/overview/e-commerce/TotalSavings';

interface ChartData {
  categories?: number[];
  series: {
    name: string;
    data: number[];
  }[];
}
const forecastData: ChartData = {
  categories: [2024, 2025, 2026, 2027, 2028, 2029, 2030, 2031, 2032, 2033],
  series: [{
    name: 'Total Savings',
    data: [1,2,4,7,14,24,36,49,63,77],
  }],
};

const ForecastBarData: React.FC = () => (
  <>
     <EcommerceSavingSales
    id="demo__4"
    title="Total Savings"
    chart={forecastData}
  />
  </>
);

export default ForecastBarData;
